import { render, staticRenderFns } from "./UseGetPicaForYourEvent.vue?vue&type=template&id=59bb55be"
import script from "./UseGetPicaForYourEvent.vue?vue&type=script&lang=js"
export * from "./UseGetPicaForYourEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports